export default "__VITE_ASSET__DQ5kMMSr__"